import React, { useState } from 'react';
import { Toast } from '../components/ui/Toast';

export function useToast() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [variant, setVariant] = useState<'default' | 'success' | 'error' | 'warning'>('default');

  const toast = {
    success: (title: string, description?: string) => {
      setTitle(title);
      setDescription(description || '');
      setVariant('success');
      setOpen(true);
    },
    error: (title: string, description?: string) => {
      setTitle(title);
      setDescription(description || '');
      setVariant('error');
      setOpen(true);
    },
    warning: (title: string, description?: string) => {
      setTitle(title);
      setDescription(description || '');
      setVariant('warning');
      setOpen(true);
    },
    info: (title: string, description?: string) => {
      setTitle(title);
      setDescription(description || '');
      setVariant('default');
      setOpen(true);
    },
  };

  const ToastComponent = (
    <Toast
      title={title}
      description={description}
      variant={variant}
      open={open}
      onOpenChange={setOpen}
    />
  );

  return { toast, ToastComponent };
}